import { getApiConfig } from "helpers/authHelper"
import { put } from "../apiHelper"
import * as url from "../urlHelper"

export const updateTrainingParticipant = (id, data) => {
  return put(`${url.TRAINING_PARTICIPANTS}/${id}`, data, getApiConfig(true))
}
